import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store'
import 'animate.css';
import message from './utils/message';

Vue.prototype.$message = message;

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  created() {
    // 初始化登录信息
    this.$store.dispatch('initAuth');
  },
  render: (h) => h(App),
}).$mount('#app');
